export { MiniState } from './state.class';
export { MiniStore } from './store.class';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /app/SPA/~/ngx-bootstrap/mini-ngrx/index.js
// module id = ../../../../ngx-bootstrap/mini-ngrx/index.js
// module chunks = 4